import isEmpty from 'lodash/isEmpty';
import {
  IStoreColors,
  IStyleCustomizations,
} from '../models/stores/sub-stores/Configuration';

type InitialStyleOptions = {
  text: string | null;
  bg: string | null;
  font: string | null;
};

export const applyInitialStyles = (options: InitialStyleOptions): void => {
  const { text, bg, font } = options;
  if (text) {
    document.documentElement.style.setProperty(
      '--main-accent-color',
      `#${text}`
    );
  }
  if (bg) {
    document.documentElement.style.setProperty(
      '--main-background-color',
      `#${bg}`
    );
  }
  if (font) {
    document.documentElement.style.setProperty('--primary-font', font);
  }
};

export const applyLegacyStyles = (colors: IStoreColors): void => {
  if (!isEmpty(colors.primary)) {
    document.documentElement.style.setProperty(
      '--button-background-color',
      colors.primary
    );
  }
};

export const applyGlobalStyles = (styles: IStyleCustomizations): void => {
  if (!isEmpty(styles.primaryFont)) {
    document.documentElement.style.setProperty(
      '--primary-font',
      styles.primaryFont
    );
  }
  if (!isEmpty(styles.buttonBackgroundColor)) {
    document.documentElement.style.setProperty(
      '--button-background-color',
      styles.buttonBackgroundColor
    );
  }
  if (!isEmpty(styles.buttonTextColor)) {
    document.documentElement.style.setProperty(
      '--button-text-color',
      styles.buttonTextColor
    );
  }
};

export const applyCheckoutPanelMainStyles = (styles: IStyleCustomizations) => {
  if (!isEmpty(styles.mainBackgroundColor)) {
    document.documentElement.style.setProperty(
      '--main-background-color',
      styles.mainBackgroundColor
    );
  }
  if (!isEmpty(styles.mainAccentColor)) {
    document.documentElement.style.setProperty(
      '--main-accent-color',
      styles.mainAccentColor
    );
  }
  if (!isEmpty(styles.mainLinkColor)) {
    document.documentElement.style.setProperty(
      '--main-link-color',
      styles.mainLinkColor
    );
  }
  if (!isEmpty(styles.mainSectionHeaderColor)) {
    document.documentElement.style.setProperty(
      '--main-section-header-color',
      styles.mainSectionHeaderColor
    );
  }
};

export const hexToRgb = (color: string): string => {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  return `${r},${g},${b}`;
};

const selectArrowAsString = `url('data:image/svg+xml;utf8,<svg width="11" height="6" viewBox="0 0 11 6" xmlns="http://www.w3.org/2000/svg"><path d="M1.69705 0L5.33507 3.72152L8.97308 0L10.0868 1.13924L5.33507 6L0.583374 1.13924L1.69705 0Z" fill="rgb(insert-rgb-here)"/></svg>')`;

export const applyCheckoutPanelFormStyles = (styles: IStyleCustomizations) => {
  if (!isEmpty(styles.formBackgroundColor)) {
    document.documentElement.style.setProperty(
      '--form-background-color',
      styles.formBackgroundColor
    );
  }
  if (!isEmpty(styles.formAccentColor)) {
    document.documentElement.style.setProperty(
      '--form-accent-color',
      styles.formAccentColor
    );
  }
  const selectArrowParts = selectArrowAsString.split('insert-rgb-here');
  if (!isEmpty(styles.formAccentColor)) {
    document.documentElement.style.setProperty(
      '--select-arrow-icon-url',
      `${selectArrowParts[0]}${hexToRgb(styles.formAccentColor)}${
        selectArrowParts[1]
      }`
    );
  }
};

export const applySummaryPanelOrderStyles = (styles: IStyleCustomizations) => {
  if (!isEmpty(styles.orderSummaryBackgroundColor)) {
    document.documentElement.style.setProperty(
      '--order-summary-background-color',
      styles.orderSummaryBackgroundColor
    );
  }
  if (!isEmpty(styles.orderSummaryAccentColor)) {
    document.documentElement.style.setProperty(
      '--order-summary-accent-color',
      styles.orderSummaryAccentColor
    );
  }
};
export const applySummaryPanelCartStyles = (styles: IStyleCustomizations) => {
  if (!isEmpty(styles.cartSummaryBackgroundColor)) {
    document.documentElement.style.setProperty(
      '--cart-summary-background-color',
      styles.cartSummaryBackgroundColor
    );
  }
  if (!isEmpty(styles.cartSummaryAccentColor)) {
    document.documentElement.style.setProperty(
      '--cart-summary-accent-color',
      styles.cartSummaryAccentColor
    );
  }
};
